const videos = document.querySelectorAll('.block--video iframe')
videos.forEach(video => {

    const width = video.getAttribute('width')
    const height = video.getAttribute('height')

    if (width && height) {
        const ratio = height/width;
        const wrapper = document.createElement('div');
        video.style.position = 'absolute'
        video.setAttribute('width', '100%')
        video.setAttribute('height', '100%')
        wrapper.style.width = '100%'
        const percent = ratio*100
        wrapper.style.paddingBottom = `${percent.toFixed(2)}%`
        wrapper.style.position = 'relative'
        wrapper.appendChild(video.cloneNode(true));
        video.replaceWith(wrapper);
    }
})